import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Flex, Button } from '@jisr-hr/design-system'
import { useFormState } from 'react-final-form'
import I18n from 'translations/i18n'
import { isNextDay, replaceAmPm } from 'components/global/form/formNormalize'

import { ReactComponent as EditIcon } from '../icons/edit.svg'

import Text16 from './Text16'
import CorrectionBadge from './CorrectionBadge'
import { reportMethodIcons } from '../helper'

import Styles from '../ProposedCorrectionTime.module.css'

const DisplayPunch = ({ type, handleEdit }) => {
  const {
    values: { shift, ...rest },
  } = useFormState()
  const { attendance_record } = useSelector(
    ({ employeeAttendanceDetails }) => employeeAttendanceDetails,
  )

  const correctionDetail = rest?.[type] || {}
  const record = attendance_record?.[0]
  const selectedShift = record?.employee_shifts?.find((option) => option?.id === shift)
  const inTime = rest?.in_punch?.punch_time || selectedShift?.in_time || record?.in_time
  const isNext = isNextDay(inTime, correctionDetail?.punch_time)

  return (
    <React.Fragment>
      <Flex
        itemsCenter
        style={{ gap: 8 }}
      >
        <Text16 label={replaceAmPm(correctionDetail?.punch_time)} />

        <Flex
          flexWrap
          itemsCenter
          className={Styles.punchDetail}
        >
          {correctionDetail?.reporting_method_i18n && (
            <CorrectionBadge
              type="gray"
              label={correctionDetail?.reporting_method_i18n}
              icon={reportMethodIcons[correctionDetail?.reporting_method]}
            />
          )}

          {isNext && type === 'out_punch' && (
            <CorrectionBadge
              type="primary"
              label={I18n.t('next_day')}
            />
          )}

          <Button
            variant="tertiary"
            size="small"
            label={I18n.t('edit')}
            startIcon={
              <EditIcon
                width={16}
                height={16}
                className={Styles.primaryDefault}
              />
            }
            onClick={handleEdit}
          />
        </Flex>
      </Flex>
    </React.Fragment>
  )
}

DisplayPunch.propTypes = {
  type: PropTypes.string,
  handleEdit: PropTypes.func,
}

export default DisplayPunch
